import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { InputRef } from 'antd';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DevExButton } from './DevExButton';
import { DevExInput, DevExInputProps } from './DevExInput';

type DevExSearchProps = {
  placeholder?: string;
  collapsible?: boolean;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  outline?: boolean;
  disabled?: boolean;
} & Pick<DevExInputProps, 'size'>;

export const DevExSearch: React.FC<DevExSearchProps> = (props) => {
  const [searchVisibility, setSearchVisibility] = useState(props.collapsible ? false : null);
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (props.collapsible) {
      inputRef.current?.focus();
    }
  }, [searchVisibility]);

  useEffect(() => {
    if (props.collapsible && props.searchQuery === '') {
      setSearchVisibility(false);
    }
  }, [props.searchQuery]);

  if (!props.collapsible || searchVisibility) {
    return (
      <DevExInput
        ref={inputRef}
        addonBefore={
          <FontAwesomeIcon
            icon={faSearch}
            onClick={searchVisibility ? () => setSearchVisibility(!searchVisibility) : undefined}
          />
        }
        placeholder={props.placeholder}
        value={props.searchQuery}
        onChange={props.setSearchQuery}
        style={{ width: 250 }}
        allowClear
        disabled={props.disabled}
        size={props.size}
      />
    );
  }
  // maps the size of the input to the size of the button
  const sizeMap = { small: 'default' };

  // the icon button is shorter than the full input, causing an issue with layout shifting
  // making the button large makes it a circle
  return (
    <DevExButton
      onClick={() => setSearchVisibility(!searchVisibility)}
      icon={<FontAwesomeIcon icon={faSearch} />}
      size={(props.size ? sizeMap[props.size] : 'large') || 'large'}
      type={props.outline ? 'outline' : 'default'}
      disabled={props.disabled}
    />
  );
};
